import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungSBriefArchivListStatus: 'idle',
    loadMeldungSBriefArchivListError: undefined as any,
    loadMeldungSBriefArchivListLastArgs: undefined as any,
    loadMeldungSBriefArchivStatus: 'idle',
    loadMeldungSBriefArchivError: undefined as any,
    saveMeldungSBriefArchivStatus: 'idle',
    saveMeldungSBriefArchivError: undefined as any,
    deleteMeldungSBriefArchivStatus: 'idle',
    deleteMeldungSBriefArchivError: undefined as any,

    meldungSBriefArchivList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungSBriefArchivList = createAsyncThunk('meldungSBriefArchivSlice/loadMeldungSBriefArchivList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungSBriefArchivSlice.loadMeldungSBriefArchivListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremserienbrief/?action=gte&MIN_MODULTYPE=2&MAX_MODULTYPE=2&MIN_MODULOBJID=${parentModel.HDR_ID}&MAX_MODULOBJID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungSBriefArchivListStatus } = getState().meldungSBriefArchivSlice
        return loadMeldungSBriefArchivListStatus !== 'pending'
    }
})

export const loadMeldungSBriefArchiv = createAsyncThunk('meldungSBriefArchivSlice/loadMeldungSBriefArchiv', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremserienbrief/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungSBriefArchivStatus } = getState().meldungSBriefArchivSlice
        return loadMeldungSBriefArchivStatus !== 'pending'
    }
})

export const saveMeldungSBriefArchiv = createAsyncThunk('meldungSBriefArchivSlice/saveMeldungSBriefArchiv', async ({ meldungSBriefArchiv }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungSBriefArchiv?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ncremserienbrief/${ meldungSBriefArchiv?.HDR_ID }/`,
            prepareData(meldungSBriefArchiv),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ncremserienbrief/`,
            prepareData(meldungSBriefArchiv),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungSBriefArchivStatus } = getState().meldungSBriefArchivSlice
        return saveMeldungSBriefArchivStatus !== 'pending'
    }
})

export const deleteMeldungSBriefArchiv = createAsyncThunk('meldungSBriefArchivSlice/deleteMeldungSBriefArchiv', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ncremserienbrief/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungSBriefArchivStatus } = getState().meldungSBriefArchivSlice
        return deleteMeldungSBriefArchivStatus !== 'pending'
    }
})

const MeldungSBriefArchivSlice = createSlice({
    name: 'meldungSBriefArchivSlice',
    initialState,
    reducers: {
        resetloadMeldungSBriefArchivListError: (state) => {
            state.loadMeldungSBriefArchivListError = undefined
        },
        resetloadMeldungSBriefArchiv: (state) => {
            state.formItem = undefined
            state.loadMeldungSBriefArchivError = undefined
        },
        resetloadMeldungSBriefArchivError: (state) => {
            state.loadMeldungSBriefArchivError = undefined
        },
        resetsaveMeldungSBriefArchiv: (state) => {
            state.formItem = undefined
            state.saveMeldungSBriefArchivError = undefined
        },
        resetsaveMeldungSBriefArchivError: (state) => {
            state.saveMeldungSBriefArchivError = undefined
        },
        resetdeleteMeldungSBriefArchivError: (state) => {
            state.deleteMeldungSBriefArchivError = undefined
        },
        removeFromMeldungSBriefArchivListById: (state, action) => {
            state.meldungSBriefArchivList = state.meldungSBriefArchivList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungSBriefArchivListByIds: (state, action) => {
            state.meldungSBriefArchivList = state.meldungSBriefArchivList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungSBriefArchivList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungSBriefArchivListStatus = 'preloaded'
            state.loadMeldungSBriefArchivListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungSBriefArchivList = []
            state.loadMeldungSBriefArchivListStatus = 'idle'
            state.loadMeldungSBriefArchivListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungSBriefArchivList.pending, (state) => {
            state.loadMeldungSBriefArchivListStatus = 'pending'
            state.loadMeldungSBriefArchivListError = undefined
        })
        builder.addCase(loadMeldungSBriefArchivList.fulfilled, (state, action) => {
            state.loadMeldungSBriefArchivListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungSBriefArchivListLastArgs = action.payload.args

            {
                state.meldungSBriefArchivList = action.payload.data

            }
        })
        builder.addCase(loadMeldungSBriefArchivList.rejected, (state, action) => {
            state.loadMeldungSBriefArchivListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungSBriefArchivListError = action.error.message
            } else {
                state.loadMeldungSBriefArchivListError = action.payload
            }
        })

        builder.addCase(loadMeldungSBriefArchiv.pending, (state) => {
            state.loadMeldungSBriefArchivStatus = 'pending'
            state.loadMeldungSBriefArchivError = undefined
        })
        builder.addCase(loadMeldungSBriefArchiv.fulfilled, (state, action) => {
            state.loadMeldungSBriefArchivStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungSBriefArchivList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungSBriefArchivList.push(newItem) }
                else { state.meldungSBriefArchivList[i] = { ...state.meldungSBriefArchivList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungSBriefArchiv.rejected, (state, action) => {
            state.loadMeldungSBriefArchivStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungSBriefArchivError = action.error.message
            } else {
                state.loadMeldungSBriefArchivError = action.payload
            }
        })

        builder.addCase(saveMeldungSBriefArchiv.pending, (state) => {
            state.saveMeldungSBriefArchivStatus = 'pending'
            state.saveMeldungSBriefArchivError = undefined
        })
        builder.addCase(saveMeldungSBriefArchiv.fulfilled, (state, action) => {
            state.saveMeldungSBriefArchivStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungSBriefArchivList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungSBriefArchivList.push(newItem) }
                else { state.meldungSBriefArchivList[i] = { ...state.meldungSBriefArchivList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungSBriefArchiv.rejected, (state, action) => {
            state.saveMeldungSBriefArchivStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungSBriefArchivError = action.error.message
            } else {
                state.saveMeldungSBriefArchivError = action.payload
            }
        })

        builder.addCase(deleteMeldungSBriefArchiv.pending, (state) => {
            state.deleteMeldungSBriefArchivStatus = 'pending'
            state.deleteMeldungSBriefArchivError = undefined
        })
        builder.addCase(deleteMeldungSBriefArchiv.fulfilled, (state, action) => {
            state.deleteMeldungSBriefArchivStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungSBriefArchivList = state.meldungSBriefArchivList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungSBriefArchivList = state.meldungSBriefArchivList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungSBriefArchiv.rejected, (state, action) => {
            state.deleteMeldungSBriefArchivStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungSBriefArchivError = action.error.message
            } else {
                state.deleteMeldungSBriefArchivError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungSBriefArchivListError,
    resetloadMeldungSBriefArchiv,
    resetloadMeldungSBriefArchivError,
    resetsaveMeldungSBriefArchiv,
    resetsaveMeldungSBriefArchivError,
    resetdeleteMeldungSBriefArchivError,
    removeFromMeldungSBriefArchivListById,
    removeFromMeldungSBriefArchivListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungSBriefArchivSlice.actions
export default MeldungSBriefArchivSlice.reducer
